// Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.

// NOTE: Add the metric name on AWSErmineWebAppLoggingServiceCDK to create metric filters.
// There are 2 types of metric filters.
// 1. Publishing count/value metric. This is used for regular count and latency metrics.
// 2. Publishing HTTP status code metric. This is for capturing HTTP status code metrics.
export enum METRIC_NAME {
  COGNITO_CALL = "CognitoCallCount",
  COGNITO_FAILURE = "CognitoFailure",
  COGNITO_LOGIN_SUCCESS = "CognitoLoginSuccess",
  CLICK = "ClickCount",
  START_STREAMING = "StartStreaming",
  STREAMING_URL_CACHE_HIT = "StreamingURLCacheHit",
  CREATE_REMOTE_BROWSER = "CreateRemoteBrowser",
  REFRESH = "RefreshCount",
  FROM_PHONE = "FromPhone",
  FROM_TABLET = "FromTablet",
  FROM_DESKTOP = "FromDesktop",
  HARDWARE_COMPATIBILITY_SUCCESS = "HardwareCompatibilitySuccess",
  HARDWARE_COMPATIBILITY_FAILURE = "HardwareCompatibilityFailure",
  DEVICE_BROWSER = "DeviceBrowser",
  DEVICE_OS = "DeviceOS",
  DEVICE_MODEL = "DeviceModel",
  DEVICE_TYPE = "DeviceType",
  DEVICE_TOUCHSCREEN = "DeviceTouchScreen",
  APPSTREAM_EMBED_SERVER_ERROR = "AppStreamEmbedServerError",
  OIDC_GET_COOKIE_SYNC_CONFIG = "OidcGetCookieSynchronizationConfiguration",
  SIGV4_GET_COOKIE_SYNC_CONFIG = "Sigv4GetCookieSynchronizationConfiguration",
  MISSING_COOKIE_SYNC_EXTENSION = "MissingCookieSynchronizationExtension",
  COOKIE_EXTENSION_RESPONSE = "CookieExtensionResponse",
  COOKIE_EXTENSION_RESPONSE_TIME = "CookieExtensionResponseTime",
}

export enum TOOLBAR_METRIC_NAME {
  TOOLBAR_VERSION = "ToolbarVersion",
  IME_TOGGLE_SUCCESS = "ImeToggleSuccess",
  IME_TOGGLE_ERROR = "ImeToggleError",
  IME_TOGGLE_DEFAULT_SUCCESS = "ImeToggleDefaultSuccess",
  IME_TOGGLE_DEFAULT_ERROR = "ImeToggleDefaultError",
  STREAMING_BEST_RESPONSIVE_SUCCESS = "StreamingBestResponsiveSuccess",
  STREAMING_BEST_RESPONSIVE_DEFAULT_SUCCESS = "StreamingBestResponsiveDefaultSuccess",
  STREAMING_BEST_RESPONSIVE_ERROR = "StreamingBestResponsiveError",
  STREAMING_BEST_QUALITY_SUCCESS = "StreamingBestQualitySuccess",
  STREAMING_BEST_QUALITY_ERROR = "StreamingBestQualityError",
  SET_COMMAND_AS_CONTROL_KEY_SUCCESS = "SetCommandAsControlKeySuccess",
  SET_COMMAND_AS_CONTROL_KEY_ERROR = "SetCommandAsControlKeyError",
  SET_COMMAND_AS_CONTROL_KEY_DEFAULT_SUCCESS = "SetCommandAsControlKeyDefaultSuccess",
  SET_COMMAND_AS_META_KEY_SUCCESS = "SetCommandAsMetaKeySuccess",
  SET_COMMAND_AS_META_KEY_DEFAULT_SUCCESS = "SetCommandAsMetaKeyDefaultSuccess",
  SET_COMMAND_AS_META_KEY_ERROR = "SetCommandAsMetaKeyError",
  TOOLBAR_MOVED = "ToolbarMoved",
  SESSION_STARTED_RESPONSE_TIME = "SessionStartedResponseTime",
  TOOLBAR_EXPANDED_DURAION_RATIO = "ToolbarExpandedDurationRatio",
  EXPAND_BUTTON_CLICK_COUNT = "ExpandButtonClickCount",
  EXPAND_HANDLE_CLICK_COUNT = "ExpandHandleClickCount",
  COLLAPSE_BUTTON_CLICK_COUNT = "CollapseButtonClickCount",
  COLLAPSE_HANDLE_CLICK_COUNT = "CollapseHandleClickCount",
  SET_DEFAULT_DARK_MODE = "SetDefaultDarkMode",
  SET_DARK_MODE = "SetDarkMode",
  SET_LIGHT_MODE = "SetLightMode",
  CYCLE_TO_NEXT_WINDOW_SUCCESS = "CycleToNextWindowSuccess",
  CYCLE_TO_NEXT_WINDOW_ERROR = "CycleToNextWindowError",
  LAUNCH_CRHOME_WINDOW_SUCCESS = "LaunchChromeWindowSuccess",
  LAUNCH_CRHOME_WINDOW_ERROR = "LaunchChromeWindowError",
  DUAL_MONITOR_SUCCESS = "DualMonitorSuccess",
  DUAL_MONITOR_ERROR = "DualMonitorError",
  ENABLE_MICROPHONE_EXPANDED_VIEW_SUCCESS = "EnableMicrophoneExpandedViewSuccess",
  ENABLE_MICROPHONE_MINI_VIEW_SUCCESS = "EnableMicrophoneMiniViewSuccess",
  ENABLE_MICROPHONE_ERROR = "EnableMicrophoneError",
  DISABLE_MICROPHONE_EXPANDED_VIEW_SUCCESS = "DisableMicrophoneExpandedViewSuccess",
  DISABLE_MICROPHONE_MINI_VIEW_SUCCESS = "DisableMicrophoneMiniViewSuccess",
  DISABLE_MICROPHONE_ERROR = "DisableMicrophoneError",
  MICROPHONE_ENABLED_DURATION_RATIO = "MicrophoneEnabledDurationRatio",
}
